import React, {Component} from "react";
import {Select, Modal, Input, Checkbox, Button, DatePicker, Upload, Typography, Row, Col, Avatar} from 'antd';
import { Form } from '@ant-design/compatible';
import {bindActionCreators} from "redux";
import * as ReinigungActions from "../../redux/Reinigung/actions";
import {connect} from "react-redux";
import {FileAddOutlined, InboxOutlined, MinusCircleOutlined, PlusOutlined} from "@ant-design/icons";
import '../RoomPlan/reservation.style.css';
import moment from "moment/moment";

const { TextArea } = Input;
const FormItem = Form.Item;
const Option = Select.Option;
const confirm = Modal.confirm;

let BASE_URL = process.env.REACT_APP_API_URL;
let API_VERSION = process.env.REACT_APP_API_VERSION;


const formItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 },
    },
};

const formItemLayoutWithOutLabel = {
    wrapperCol: {
        xs: { span: 24, offset: 0 },
        sm: { span: 18, offset: 6 },
    },
};

let uuid = 0;


const CleaningNote = ({date, userName, file, onFilePreview, children}) => {
    const userNameArray = (userName || "").split(" ") || [];
    return (
        <div className="ReservationNote">
            <div className="ReservationNoteHeader">
                <div className="ReservationNoteAvatar"><Avatar size="small" style={{ backgroundColor: "#f52929", verticalAlign: "middle" }}>{userNameArray.map((name) => name.substring(0, 1).toUpperCase())}</Avatar></div>
                <div className="ReservationNoteTitle"><Typography.Text><b>{userName}</b></Typography.Text></div>
                <div>
                    <Typography.Text type="secondary">{moment(date).format("DD.MM.YYYY HH:mm")} Uhr</Typography.Text>
                </div>
            </div>
            <div className="ReservationNoteBody">
                {file ? <img height={150} src={file} className="ReservationNoteImage" onClick={() => onFilePreview(file)} /> : null}
                <Typography.Text>{children}</Typography.Text>
            </div>
        </div>
    );
};

const CleaningNoteImagePreview = ({file, onClose, open}) => {
    return (
        <Modal
            title="Bildvorschau"
            open={open}
            onCancel={onClose}
            okText={false}
            footer={null}
            style={{ maxWidth: "80vw" }}
            width={"fit-content"}
        >
            <img src={file} style={{objectFit: "contain", height: "70vh", maxHeight: "100%", maxWidth: "100%"}}/>
        </Modal>
    );
}

class ReinigungDetailModal extends Component {

    state = { cleaningNoteText: "", cleaningNoteUpload: []};

    componentWillMount() {
    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                this.props.actions.saveReinigungDetail(values, this.props.ReinigungDetailID);
            }
        });
    };


    componentWillReceiveProps(nextProps) {
        if(this.props.ReinigungModalVisible && !nextProps.ReinigungModalVisible) {
            this.setState({cleaningNoteText: "", cleaningNoteUpload: []});
            this.props.form.resetFields();
        } else if(!this.props.ReinigungModalVisible && nextProps.ReinigungModalVisible) {
            uuid = 0;
            if(nextProps.ReinigungDetailID) {
                this.props.actions.LoadReinigungDetail(nextProps.ReinigungDetailID);
            }
        }
    }

    confirmDelete = () => {
        confirm({
            title: "Reinigung löschen",
            content: "Wollen Sie diese Reinigung wirklich löschen?",
            okText: "Löschen",
            okType: 'danger',
            cancelText: "Abbrechen",
            onOk: () => this.props.actions.deleteReinigung(this.props.ReinigungDetailID),
            onCancel() {
            },
        });
    };

    removeToDo = (k) => {
        const { form } = this.props;
        const keys = form.getFieldValue('keys');
        form.setFieldsValue({
            keys: keys.filter(key => key !== k),
        });
    };

    addToDo = () => {
        const { form } = this.props;
        const keys = form.getFieldValue('keys');
        const nextKeys = keys.concat(uuid);
        uuid++;

        form.setFieldsValue({
            keys: nextKeys,
            Checked: false,
        });
    };


    sendCleaningNote = () => {
        const note = this.state.cleaningNoteText;
        const file = this.state.cleaningNoteUpload?.[0];
        if(note) {
            this.props.actions.saveCleaningNote({note, file}, this.props.ReinigungDetailID).then((resp) => {
                if (resp?.type === "SAVE_REINIGUNG_CLEANING_NOTE_SUCCESS") {
                    this.setState({cleaningNoteText: "", cleaningNoteUpload: []});
                }
            });
        }
    }


    render() {
        const { getFieldDecorator, getFieldValue, setFieldsValue } = this.props.form;
        //getFieldDecorator('keys', { initialValue: this.props.workflowList.map((c, i) => {return i;}) });
        getFieldDecorator('keys', { initialValue: this.props.ReinigungDetail?.todos ? this.props.ReinigungDetail.todos.map((c, i) => {return i;} ) : []} );
        const keys = this.props.form.getFieldValue('keys');

        if(this.props.ReinigungDetail?.todos && uuid < this.props.ReinigungDetail?.todos?.length || 0) { uuid = this.props.ReinigungDetail?.todos?.length || 0; }

        let formItems = keys.map((k, index) => {
            return (
                <Row gutter={0}>
                    <Col span={6} style={{textAlign: 'center'}}>
                        <FormItem
                            {...formItemLayoutWithOutLabel}
                            label={''}
                            required={false}
                            key={k+'C'}
                        >
                            {getFieldDecorator(`todosC[${k}]`, {
                                validateTrigger: ['onChange', 'onBlur'],
                                initialValue: this.props.ReinigungDetail?.todos ? this.props.ReinigungDetail?.todos[k] ? this.props.ReinigungDetail.todos[k].Done : false : false,
                                valuePropName: 'checked',
                            })(
                                <Checkbox onChange={(e) => !e.target.checked && setFieldsValue({
                                    Checked: false,
                                })} />
                            )}
                        </FormItem>

                    </Col>

                    <Col span={18} style={{textAlign: 'left'}}>

                        <FormItem
                            label={''}
                            required={false}
                            key={k}
                        >
                            {getFieldDecorator(`todos[${k}]`, {
                                validateTrigger: ['onChange', 'onBlur'],
                                initialValue: this.props.ReinigungDetail?.todos ? this.props.ReinigungDetail.todos[k] ? this.props.ReinigungDetail.todos[k].Job : "" : "",
                                rules: [{
                                    required: true,
                                    whitespace: true,
                                    message: "Bitte geben Sie eine Aufgabe ein, oder entfernen Sie dieses Feld",
                                }],
                            })(
                                <Input placeholder="Aufgabe eingeben" style={{ width: '77%', marginRight: 8 }} />
                            )}
                            { (getFieldValue(`todos[${k}]`)?.length === 0 || getFieldValue(`todosC[${k}]`)) ?
                                <MinusCircleOutlined
                                    className="dynamic-delete-button"
                                    onClick={() => this.removeToDo(k)}
                                /> : ''
                            }
                            {getFieldDecorator(`todosU[${k}]`, {
                                initialValue: this.props.ReinigungDetail?.todos && this.props.ReinigungDetail?.todos?.[k] ? this.props.ReinigungDetail?.todos?.[k]?.DoneFromID : undefined,
                            })}
                            {getFieldDecorator(`todosS[${k}]`, {
                                initialValue: this.props.ReinigungDetail?.todos && this.props.ReinigungDetail?.todos?.[k] ? this.props.ReinigungDetail?.todos?.[k]?.schedule : null,
                                rules: [{
                                    required: false,
                                }],
                            })(
                                <Select
                                    getPopupContainer={trigger => trigger.parentNode}
                                    showSearch
                                    style={{ width: '77%' }}
                                    placeholder="Wiederholung"
                                    optionFilterProp="children"
                                    filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                >
                                    <Option value={null}>Nicht wiederholen</Option>
                                    <Option value={"daily"}>Täglich wiederholen</Option>
                                    <Option value={"weekly"}>Wöchentlich wiederholen</Option>
                                    <Option value={"monthly"}>Monatlich wiederholen</Option>
                                    <Option value={"yearly"}>Jährlich wiederholen</Option>
                                </Select>
                            )}
                            {this.props.ReinigungDetail?.todos?.[k]?.Done ? <><br/><Typography.Text type="secondary">Erledigt
                                von: {this.props.ReinigungDetail?.todos[k]?.DoneFrom}</Typography.Text></> : null}


                            {getFieldDecorator(`todosD[${k}]`, {
                                rules: [{
                                    required: false,
                                }],
                                initialValue: this.props.ReinigungDetail?.todos?.[k]?.date ? moment(this.props.ReinigungDetail?.todos?.[k]?.date) : null,
                            })(
                                <DatePicker placeholder={"Datum auswählen"} format={"DD.MM.YYYY"} style={{width: '77%'}}/>)}

                        </FormItem>
                    </Col>
                </Row>
            );
        });


        return (
            <>
                <CleaningNoteImagePreview file={this.state.CleaningNoteFilePreview} open={!!this.state.CleaningNoteFilePreview} onClose={() => this.setState({CleaningNoteFilePreview: undefined})} />
                <Modal
                    title={`Reinigung ${this.props.ReinigungDetailID ? 'bearbeiten' : 'anlegen'}`}
                    visible={this.props.ReinigungModalVisible}
                    onOk={this.handleSubmit}
                    onCancel={() => this.props.actions.showReinigungModal(false, null)}
                    cancelText={"Abbrechen"}
                    okText={"Speichern"}
                    width={"750px"}
                    footer={[
                        this.props.ReinigungDetailID ? <Button key="deleteban" type="danger" loading={this.props.deletingBan} onClick={this.confirmDelete}>
                            Reinigung löschen
                        </Button> : '',
                        <Button key="cancel" onClick={() => this.props.actions.showReinigungModal(false, null)}>Abbrechen</Button>,
                        <Button key="submit" type="primary" loading={this.props.ReinigungModalSaving} onClick={this.handleSubmit}>
                            Speichern
                        </Button>
                    ]}
                >



                    <form onSubmit={this.handleSubmit} style={{width: '100%'}}>

                        <FormItem
                            {...formItemLayout}
                            label={"Raum"}
                            required={true}
                            key={'Room'}
                        >
                            {getFieldDecorator('Room', {
                                initialValue: this.props.ReinigungDetail.Room,
                                rules: [{
                                    required: true,
                                    whitespace: true,
                                    message: "Bitte geben Sie diese Information an."
                                }],
                            })(
                                <Input type={"text"} placeholder={"Raum"} style={{ width: 380 }}/>
                            )}
                        </FormItem>

                        <FormItem
                            {...formItemLayout}
                            label={'Geprüft'}
                            required={false}
                            key={"Geprüft"}
                        >
                            {getFieldDecorator(`Checked`, {
                                validateTrigger: ['onChange', 'onBlur'],
                                initialValue: this.props.ReinigungDetail.Checked,
                                valuePropName: 'checked',
                            })(
                                <Checkbox />
                            )}
                        </FormItem>

                        <FormItem {...formItemLayout} label={"Aufgaben"}>
                        </FormItem>
                        {formItems}
                        <FormItem {...formItemLayoutWithOutLabel}>
                            <Button type="dashed" onClick={this.addToDo} style={{ width: '77%', margin: "0 auto" }}>
                                <PlusOutlined /> Aufgabe Hinzufügen
                            </Button>
                        </FormItem>

                        <div className="ReservationNoteWrapper">
                            {(this.props.ReinigungDetail?.cleaningNotes || []).map((cleaningNote) =>
                                <CleaningNote userName={cleaningNote.User} date={cleaningNote.Created} file={cleaningNote.File} onFilePreview={(file) => this.setState({CleaningNoteFilePreview: file})}>{cleaningNote.Note}</CleaningNote>
                            )}
                            {!this.props.ReinigungDetail?.cleaningNotes?.length && <Typography.Text type="secondary" style={{display: "block", textAlign: "center"}}>Keine Notizen vorhanden</Typography.Text>}
                        </div>
                        <div className="ReservationNoteInputWrapper">
                            <div className="ReservationNoteInputContainer">
                                <Upload
                                    accept="image/*"
                                    action={(f) => BASE_URL+'api/'+API_VERSION+"/cleaning/"+(this.props.ReinigungDetailID)+"/cleaningnote/Upload/"+f.uid}
                                    headers={{authorization: `Bearer ${localStorage.getItem('id_token') || null}`}}
                                    onChange={({fileList}) => {this.setState({cleaningNoteUpload: fileList.slice(-1)});}}
                                    fileList={this.state.cleaningNoteUpload}
                                    showUploadList={false}
                                    multiple={false}
                                    disabled={!this.props.ReinigungDetailID || this.props.ReinigungDetailCleaningNoteSaving}
                                >
                                    <Button type="default" htmlType="button" icon={<FileAddOutlined />} />
                                </Upload>
                                <div className="ReservationNoteInputs">
                                    {/*!this.state.cleaningNoteUpload?.length ? <TextArea disabled={!this.props.ReinigungDetailID || this.props.ReinigungDetailCleaningNoteSaving} value={this.state.cleaningNoteText} onChange={(e) => { this.setState({cleaningNoteText: e.target.value}); }} /> : null*/}
                                    <TextArea placeholder={"Nachricht eingeben..."} disabled={!this.props.ReinigungDetailID || this.props.ReinigungDetailCleaningNoteSaving} value={this.state.cleaningNoteText} onChange={(e) => { this.setState({cleaningNoteText: e.target.value}); }} />
                                    <Upload fileList={this.state.cleaningNoteUpload}  onChange={({fileList}) => {this.setState({cleaningNoteUpload: fileList});}} />
                                </div>
                                <Button htmlType="button" type="primary" onClick={this.sendCleaningNote} disabled={this.props.ReinigungDetailCleaningNoteSaving}>Senden</Button>
                            </div>
                        </div>



                    </form>


                </Modal>
                </>
        );
    }
}



function mapStateToProps(state) {
    const { ReinigungReducer } = state;
    const { ReinigungModalVisible, ReinigungDetailID, ReinigungModalSaving, ReinigungDetail , deletingBan} = ReinigungReducer;
    return {
        ReinigungModalVisible,
        ReinigungDetailID,
        ReinigungModalSaving,
        ReinigungDetail,
        deletingBan
    };
}


function mapDispatchToProps(dispatch) {
    return{
        actions: bindActionCreators(ReinigungActions, dispatch)
    };
}



export default connect(mapStateToProps, mapDispatchToProps)(Form.create()(ReinigungDetailModal));


//export default Form.create()(UsersDetailModal);